import axios, { AxiosError, AxiosResponse } from 'axios';
import { SETTINGS } from '../init';
import Rollbar from './rollbar';

const rmnApi = async <T>(
  path: string,
  requestBody: unknown,
): Promise<AxiosResponse<T>> => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios
    .post(`${SETTINGS.API_URL}${path}`, requestBody, {
      headers,
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.status !== 403) {
          Rollbar.error(error.message, error, {
            data: error.response.data,
            status: error.response.status,
            headers: error.response.headers,
          });
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest
        Rollbar.warning(error.message, error, {
          request: error.request,
        });
      } else {
        Rollbar.error(error.message, error);
      }
      throw error;
    });
};

export default rmnApi;
